import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getParty = () => axios.get(`${API}/party`).then((r) => r.data);
export const getBoard = () => axios.get(`${API}/board`).then((r) => r.data);
export const createRsvp = (data) => axios.post(`${API}/rsvp`, data).then((r) => r.data);
export const lookupRsvp = (phone) => axios.post(`${API}/rsvp/lookup`, { phone }).then((r) => r.data);
export const updateRsvp = (id, data) => axios.put(`${API}/rsvp/${id}`, data).then((r) => r.data);
export const cancelRsvp = (phone) => axios.delete(`${API}/rsvp`, { data: { phone } }).then((r) => r.data);
export const castVote = (data) => axios.post(`${API}/votes`, data).then((r) => r.data);
export const getResults = () => axios.get(`${API}/votes/results`).then((r) => r.data);
export const getPhotos = () => axios.get(`${API}/photos`).then((r) => r.data);
export const uploadPhoto = (file, name) => {
  const form = new FormData();
  form.append("file", file);
  form.append("name", name);
  return axios.post(`${API}/photos`, form).then((r) => r.data);
};
export const photoUrl = (id) => `${API}/photos/${id}/image`;
export const revealWinner = (revealed) => axios.put(`${API}/party/reveal`, { revealed }).then((r) => r.data);
export const updateParty = (data) => axios.put(`${API}/party`, data).then((r) => r.data);
export const resetParty = () => axios.post(`${API}/host/reset`).then((r) => r.data);
export const uploadWinnerPhoto = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.put(`${API}/party/winner-photo`, form).then((r) => r.data);
};
export const clearWinnerPhoto = () => axios.post(`${API}/party/winner-photo-clear`).then((r) => r.data);
export const winnerPhotoUrl = (path) => `${API}/party/winner-photo${path ? `?v=${path.slice(-12)}` : ""}`;
export const savePreset = (name) => axios.post(`${API}/presets`, { name }).then((r) => r.data);
export const getPresets = () => axios.get(`${API}/presets`).then((r) => r.data);
export const applyPreset = (id) => axios.post(`${API}/presets/${id}/apply`).then((r) => r.data);
export const deletePreset = (id) => axios.delete(`${API}/presets/${id}`).then((r) => r.data);
